<script lang="ts" setup>
import { i18n } from '@/i18n';
import InfoModal from '../InfoModal.vue';
import { computed } from 'vue';

const t = i18n.t;

const props = defineProps<{ title?: string; description?: string }>();

const title = computed(() => props.title ?? t('ローディング中'));
const description = computed(() => props.description ?? t('しばしお待ちください。'));
</script>
<template>
  <InfoModal :modal-state="true" icon="loading" :enable-outside-click="false">
    <template #title>{{ title }}</template>
    <template #description>
      {{ description }}
    </template>
  </InfoModal>
</template>
